if (!customElements.get('ajax-reload')) {
  class AjaxReload extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      const target = event.target.closest('a');
      if (!target) return;

      const urlString = target.getAttribute('href');
      if (!urlString) return;

      event.preventDefault();

      const url = new URL(urlString, window.location.origin);
      url.searchParams.set('sections', 'main-product');

      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          const html = new DOMParser().parseFromString(
            data['main-product'],
            'text/html',
          );

          this.dispatchEvent(
            new CustomEvent('update:html', { bubbles: true, detail: { html } }),
          );

          const cleanUrl = new URL(urlString, window.location.origin);
          window.history.replaceState({}, '', cleanUrl.pathname);
        })
        .catch((error) => console.log(error));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('ajax-reload', AjaxReload);
}
